// extracted by mini-css-extract-plugin
export var alertIcon = "_ts-0";